/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @next/next/no-img-element */
import { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';

//Component
import Card from 'components/Category/Card';
import CustomPagination from 'components/Pagination';
import MuiPagination from 'components/Common/Pagination/MuiPagination';
import ModalCheckout from 'components/CourseDescription/ModalCheckout';
import { Spinner } from 'react-bootstrap';
import SortData from 'components/Category/Sort';
import OpenFilterButton from 'components/Category/OpenFilterButton';
import BottomSheet from 'components/BottomSheet';
import AllFilterComponent from 'components/Category/AllFilterComponent';
import BreadcrumbSection from 'components/Category/BreadcrumbSection';
import { isMobile } from 'react-device-detect';

//Service
import { lereroFetch } from 'utils/fetch';
import { getCourseDetail } from 'services/course-description';
import { getProductDetail } from 'services/products';
import { synchronizedSingleCartData } from 'utils/manipulate_array';
import generateBreadcrumbCategory from 'utils/generate_breadcrumb_name';
import { BUNDLE, COURSE, COURSE_AND_PRODUCT, PRODUCT, PRODUCT_BUNDLE } from 'variables/item_variation';
import CardBundle from '../components/Category/CardBundle';
import { getBundleDetails } from '../services/bundles';
import { styles } from 'components/Common/Pagination/styles';
import { useWhitelabelContext } from 'context/whitelabel.context';
import Button from 'components/Button';
import { BUTTON_TYPE } from 'constants/button';
import TitleSection from 'components/Category/TitleSection';
import { SubHeading } from 'components/Typography/General';
import { FONT_TYPES } from 'variables/font_groups';
import { BLOCKED_LANGUAGES, BLOCKED_PROVIDERS } from 'variables/filter';
import {
  trackFilterApplied,
  trackFilterCleared,
  trackSearchNoResults,
  trackSearchPerformed,
  trackViewItemList,
  trackSortChanged
} from 'lib/analytics';
import { toast } from 'react-toastify';

const SORT_BY_ITEM = [
  {
    id: 'ascending',
    isChecked: true,
    name: 'A - Z',
  },
  {
    id: 'descending',
    isChecked: true,
    name: 'Z - A',
  },
  // {
  //   id: "popular",
  //   isChecked: true,
  //   name: "Most Popular",
  // },
  // {
  //   id: "highlyrate",
  //   isChecked: true,
  //   name: "Highly Rate",
  // },
  {
    id: 'newest',
    isChecked: true,
    name: 'Newest to Oldest',
  },
  {
    id: 'oldest',
    isChecked: true,
    name: 'Oldest to Newest',
  },
  {
    id: 'mostPurchased',
    isChecked: true,
    name: 'Most Popular',
  },
  {
    id: 'lowest',
    isChecked: true,
    name: 'Price : Low to High',
  },
  {
    id: 'highest',
    isChecked: true,
    name: 'Price : High to Low',
  },
];

const DEFAULT_MIN_PRICE = 0;
const DEFAULT_MAX_PRICE = 2500;

const buildPriceRangeFilter = (minPrice, maxPrice) => `&minPrice=${minPrice}&maxPrice=${maxPrice}`;

const sanitizePriceValue = (value, fallback) => {
  const parsedValue = Number(String(value ?? '').replace(/[^0-9]/g, ''));

  return Number.isFinite(parsedValue) ? parsedValue : fallback;
};

const getAvailablePriceBounds = (priceOptions) => {
  if (!Array.isArray(priceOptions) || priceOptions.length === 0) {
    return {
      min: DEFAULT_MIN_PRICE,
      max: DEFAULT_MAX_PRICE,
    };
  }

  const bounds = priceOptions.reduce(
    (accumulator, item) => {
      const nextMin = sanitizePriceValue(item?.min, Number.POSITIVE_INFINITY);
      const nextMax = sanitizePriceValue(item?.max, Number.NEGATIVE_INFINITY);

      return {
        min: Number.isFinite(nextMin) ? Math.min(accumulator.min, nextMin) : accumulator.min,
        max: Number.isFinite(nextMax) ? Math.max(accumulator.max, nextMax) : accumulator.max,
      };
    },
    {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY,
    }
  );

  return {
    min: Number.isFinite(bounds.min) ? bounds.min : DEFAULT_MIN_PRICE,
    max: Number.isFinite(bounds.max) ? bounds.max : DEFAULT_MAX_PRICE,
  };
};

const getPriceRangeFilter = (minPrice, maxPrice, defaultBounds = { min: DEFAULT_MIN_PRICE, max: DEFAULT_MAX_PRICE }) => {
  if (minPrice === defaultBounds.min && maxPrice === defaultBounds.max) {
    return '';
  }

  return buildPriceRangeFilter(minPrice, maxPrice);
};

export default function category() {
  const Router = useRouter();
  const courseFirstRender = useRef(true);
  const productFirstRender = useRef(true);
  const itemFirstRender = useRef(true);

  //#region
  const [savedFilter, setSavedFilter] = useState({});
  const [filter, setFilter] = useState(true);

  const [displayedItem, setDisplayedItem] = useState([]);
  const [isFilterTriggeredByOnClick, setIsFilterTriggeredByOnClick] = useState(false);

  const [totalFilterCourseApplied, setTotalFilterCourseApplied] = useState(0);
  const [totalFilterProductApplied, setTotalFilterProductApplied] = useState(0);
  const [totalFilterBundlesApplied, setTotalFilterBundlesApplied] = useState(0);
  const [totalFilterItemApplied, setTotalFilterItemApplied] = useState(0);

  const [isFilterMobileOpened, setIsFilterMobileOpened] = useState(false);

  const [displayedItemVariation, setDisplayedItemVariation] = useState('');

  const [sort, setSort] = useState('newest');
  const [showSort, setShowSort] = useState(false);

  const [categoryName, setCategoryName] = useState();

  // 'filter' string at beginning -> checked data of filter data
  // 'filter' string at ending -> string of joined checked filter
  //  no filter string -> array of filter data
  const [courseType, setCourseType] = useState([]);
  const [filterCourseType, setFilterCourseType] = useState([]);
  const [courseTypeFilter, setCourseTypeFilter] = useState('');

  const [learningProgram, setLearningProgram] = useState([]);
  const [filterLearningProgram, setFilterLearningProgram] = useState([]);
  const [learningProgramFilter, setLearningProgramFilter] = useState('');

  const [delivery, setDelivery] = useState([]);
  const [filterDelivery, setFilterDelivery] = useState([]);
  const [deliveryFilter, setDeliveryFilter] = useState('');

  const [duration, setDuration] = useState([]);
  const [filterDuration, setFilterDuration] = useState([]);
  const [durationFilter, setDurationFilter] = useState('');

  const [language, setLanguage] = useState([]);
  const [filterLanguage, setFilterLanguage] = useState([]);
  const [languageFilter, setLanguageFilter] = useState('');

  // const [rating, setRating] = useState([]);
  // const [filterRating, setFilterRating] = useState([]);
  // const [ratingFilter, setRatingFilter] = useState('');

  const [provider, setProvider] = useState([]);
  const [filterProvider, setFilterProvider] = useState([]);
  const [providerFilter, setProviderFilter] = useState('');

  const [price, setPrice] = useState([]);
  const [filterPrice, setFilterPrice] = useState([]);
  const [priceFilter, setPriceFilter] = useState('');

  const min = priceFilter.match(/minPrice=(\d+)/)?.[1];
  const max = priceFilter.match(/maxPrice=(\d+)/)?.[1];

  const [minPrice, setMinPrice] = useState(min ? parseInt(min) : DEFAULT_MIN_PRICE);
  const [maxPrice, setMaxPrice] = useState(max ? parseInt(max) : DEFAULT_MAX_PRICE);
  const [isDispatch, setIsDispatch] = useState(false);

  const [type, setType] = useState([]);
  const [filterType, setFilterType] = useState([]);
  const [typeFilter, setTypeFilter] = useState('');

  const [readingTime, setReadingTime] = useState([]);
  const [filterReadingTime, setFilterReadingTime] = useState([]);
  const [readingTimeFilter, setReadingTimeFilter] = useState('');

  const [languageProduct, setLanguageProduct] = useState([]);
  const [filterLanguageProduct, setFilterLanguageProduct] = useState([]);
  const [languageProductFilter, setLanguageProductFilter] = useState('');

  const [cluster, setCluster] = useState([]);
  const [filterCluster, setFilterCluster] = useState([]);
  const [clusterFilter, setClusterFilter] = useState('');

  // const [rating, setRating] = useState([]);
  // const [filterRating, setFilterRating] = useState([]);
  // const [ratingFilter, setRatingFilter] = useState('');

  const [providerProduct, setProviderProduct] = useState([]);
  const [filterProviderProduct, setFilterProviderProduct] = useState([]);
  const [providerProductFilter, setProviderProductFilter] = useState('');

  // filter course order from top to bottom
  const filterCourseOrder = ['courseType', 'learningProgram', 'delivery', 'duration', 'language', 'provider'];

  // filter products order from top to bottom
  const filterProductOrder = ['price', 'type', 'readingTime', 'language', 'provider'];
  const filterBundleOrder = ['type', 'price', 'language', 'readingTime', 'duration', 'provider'];

  // filter items (when user click provider in navbar) from top to bottom
  const filterItemOrder = [
    'courseType',
    'learningProgram',
    'delivery',
    'duration',
    'language',
    'provider',
    'price',
    'type',
    'readingTime',
    'cluster',
  ];

  // object of filter course collection to make the code cleaner
  const filterCourseCollection = {
    courseType: {
      checkedData: filterCourseType,
      setCheckedData: setFilterCourseType,
      setFilterSlug: setCourseTypeFilter,
      slug: '&courseType=',
      setFilterData: setCourseType,
    },
    learningProgram: {
      checkedData: filterLearningProgram,
      setCheckedData: setFilterLearningProgram,
      setFilterSlug: setLearningProgramFilter,
      slug: '&learningProgram=',
      setFilterData: setLearningProgram,
    },
    delivery: {
      checkedData: filterDelivery,
      setCheckedData: setFilterDelivery,
      setFilterSlug: setDeliveryFilter,
      slug: '&delivery=',
      setFilterData: setDelivery,
    },
    duration: {
      checkedData: filterDuration,
      setCheckedData: setFilterDuration,
      setFilterSlug: setDurationFilter,
      slug: '&duration=',
      setFilterData: setDuration,
    },
    language: {
      checkedData: filterLanguage,
      setCheckedData: setFilterLanguage,
      setFilterSlug: setLanguageFilter,
      slug: '&language=',
      setFilterData: setLanguage,
    },
    provider: {
      checkedData: filterProvider,
      setCheckedData: setFilterProvider,
      setFilterSlug: setProviderFilter,
      slug: '&provider=',
      setFilterData: setProvider,
    },
  };

  const filterBundleCollection = {
    price: {
      checkedData: filterPrice,
      setCheckedData: setFilterPrice,
      setFilterSlug: setPriceFilter,
      slug: '&price=',
      setFilterData: setPrice,
    },
    type: {
      checkedData: filterType,
      setCheckedData: setFilterType,
      setFilterSlug: setTypeFilter,
      slug: '&type=',
      setFilterData: setType,
    },
    readingTime: {
      checkedData: filterReadingTime,
      setCheckedData: setFilterReadingTime,
      setFilterSlug: setReadingTimeFilter,
      slug: '&readingTime=',
      setFilterData: setReadingTime,
    },
    language: {
      checkedData: filterLanguageProduct,
      setCheckedData: setFilterLanguageProduct,
      setFilterSlug: setLanguageProductFilter,
      slug: '&language=',
      setFilterData: setLanguageProduct,
    },
    duration: {
      checkedData: filterDuration,
      setCheckedData: setFilterDuration,
      setFilterSlug: setDurationFilter,
      slug: '&duration=',
      setFilterData: setDuration,
    },
    provider: {
      checkedData: filterProviderProduct,
      setCheckedData: setFilterProviderProduct,
      setFilterSlug: setProviderProductFilter,
      slug: '&provider=',
      setFilterData: setProviderProduct,
    },
  };

  // object of filter product collection to make the code cleaner
  const filterProductCollection = {
    price: {
      checkedData: filterPrice,
      setCheckedData: setFilterPrice,
      setFilterSlug: setPriceFilter,
      slug: '&price=',
      setFilterData: setPrice,
    },
    type: {
      checkedData: filterType,
      setCheckedData: setFilterType,
      setFilterSlug: setTypeFilter,
      slug: '&type=',
      setFilterData: setType,
    },
    readingTime: {
      checkedData: filterReadingTime,
      setCheckedData: setFilterReadingTime,
      setFilterSlug: setReadingTimeFilter,
      slug: '&readingTime=',
      setFilterData: setReadingTime,
    },
    language: {
      checkedData: filterLanguageProduct,
      setCheckedData: setFilterLanguageProduct,
      setFilterSlug: setLanguageProductFilter,
      slug: '&language=',
      setFilterData: setLanguageProduct,
    },
    provider: {
      checkedData: filterProviderProduct,
      setCheckedData: setFilterProviderProduct,
      setFilterSlug: setProviderProductFilter,
      slug: '&provider=',
      setFilterData: setProviderProduct,
    },
  };

  // object of filter item collection to make the code cleaner
  const filterItemCollection = {
    courseType: {
      checkedData: filterCourseType,
      setCheckedData: setFilterCourseType,
      setFilterSlug: setCourseTypeFilter,
      slug: '&courseType=',
      setFilterData: setCourseType,
    },
    learningProgram: {
      checkedData: filterLearningProgram,
      setCheckedData: setFilterLearningProgram,
      setFilterSlug: setLearningProgramFilter,
      slug: '&learningProgram=',
      setFilterData: setLearningProgram,
    },
    delivery: {
      checkedData: filterDelivery,
      setCheckedData: setFilterDelivery,
      setFilterSlug: setDeliveryFilter,
      slug: '&deliveryType=',
      setFilterData: setDelivery,
    },
    duration: {
      checkedData: filterDuration,
      setCheckedData: setFilterDuration,
      setFilterSlug: setDurationFilter,
      slug: '&duration=',
      setFilterData: setDuration,
    },
    language: {
      checkedData: filterLanguage,
      setCheckedData: setFilterLanguage,
      setFilterSlug: setLanguageFilter,
      slug: '&language=',
      setFilterData: setLanguage,
    },
    provider: {
      checkedData: filterProvider,
      setCheckedData: setFilterProvider,
      setFilterSlug: setProviderFilter,
      slug: '&provider=',
      setFilterData: setProvider,
    },
    price: {
      checkedData: filterPrice,
      setCheckedData: setFilterPrice,
      setFilterSlug: setPriceFilter,
      slug: '&price=',
      setFilterData: setPrice,
    },
    type: {
      checkedData: filterType,
      setCheckedData: setFilterType,
      setFilterSlug: setTypeFilter,
      slug: '&type=',
      setFilterData: setType,
    },
    readingTime: {
      checkedData: filterReadingTime,
      setCheckedData: setFilterReadingTime,
      setFilterSlug: setReadingTimeFilter,
      slug: '&readingTime=',
      setFilterData: setReadingTime,
    },
    cluster: {
      checkedData: filterCluster,
      setCheckedData: setFilterCluster,
      setFilterSlug: setClusterFilter,
      slug: '&cluster=',
      setFilterData: setCluster,
    },
  };

  const usedCollection = {
    [BUNDLE]: {
      filterCollection: filterBundleCollection,
      totalFilterApplied: totalFilterBundlesApplied,
    },
    [PRODUCT]: {
      filterCollection: filterProductCollection,
      totalFilterApplied: totalFilterProductApplied,
    },
    [COURSE]: {
      filterCollection: filterCourseCollection,
      totalFilterApplied: totalFilterCourseApplied,
    },
    [COURSE_AND_PRODUCT]: {
      filterCollection: filterItemCollection,
      totalFilterApplied: totalFilterItemApplied,
    },
  };

  const availablePriceBounds = useMemo(() => getAvailablePriceBounds(price), [price]);
  const isPriceRangeSelected = useMemo(() => {
    return (
      minPrice !== availablePriceBounds.min ||
      maxPrice !== availablePriceBounds.max
    );
  }, [availablePriceBounds.max, availablePriceBounds.min, maxPrice, minPrice]);

  const getSelectedFilterCount = useCallback(
    (variation) => {
      const priceCount = isPriceRangeSelected ? 1 : 0;

      switch (variation) {
        case PRODUCT:
          return (
            filterType.length +
            filterReadingTime.length +
            filterLanguageProduct.length +
            filterProviderProduct.length +
            priceCount
          );
        case BUNDLE:
          return filterType.length + filterLanguageProduct.length + filterProviderProduct.length + priceCount;
        case COURSE:
          return (
            filterCourseType.length +
            filterLearningProgram.length +
            filterDelivery.length +
            filterLanguage.length +
            filterDuration.length +
            filterProvider.length +
            priceCount
          );
        case COURSE_AND_PRODUCT:
          return (
            filterCourseType.length +
            filterLearningProgram.length +
            filterDelivery.length +
            filterLanguage.length +
            filterDuration.length +
            filterProvider.length +
            filterType.length +
            filterCluster.length +
            filterReadingTime.length +
            priceCount
          );
        default:
          return 0;
      }
    },
    [
      filterCluster.length,
      filterCourseType.length,
      filterDelivery.length,
      filterDuration.length,
      filterLanguage.length,
      filterLanguageProduct.length,
      filterLearningProgram.length,
      filterProvider.length,
      filterProviderProduct.length,
      filterReadingTime.length,
      filterType.length,
      isPriceRangeSelected,
    ]
  );

  const selectedFilterCount = useMemo(() => {
    return getSelectedFilterCount(displayedItemVariation);
  }, [displayedItemVariation, getSelectedFilterCount]);

  const [openModalCheckout, setOpenModalCheckout] = useState(false);
  const [parent, setParent] = useState('');
  const [parentUrl, setParentUrl] = useState('');
  const [filterAndSort, showFilterAndSort] = useState('filter');
  const [pagination, setPagination] = useState();
  const [cart, setCart] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const previousFiltersRef = useRef({});

  //#endregion

  function toggleClickFilterAndSort(type = '') {
    showFilterAndSort(type);
  }

  /**
   * Load all courses based on filter
   * @param page page of the course, default is 1,
   * @param limit total course in one page, default is 10
   */
  const loadCourses = async (page = 1, limit = 10, options = {}) => {
    const { priceFilterOverride, sortOverride } = options;
    const activePriceFilter = typeof priceFilterOverride === 'string' ? priceFilterOverride : priceFilter;
    const activeSort = sortOverride ?? sort;

    // setIsLoading(true);
    let filter_category = localStorage.getItem('category_name') ?? '';

    if (filter_category === '&categorySlug=all') {
      filter_category = '';
    }

    if (filter_category === '&provider=all') {
      filter_category = '';
    }

    if (filter_category?.includes('&')) {
      filter_category = filter_category.split(' & ').join('-');
    }

    if (filter_category?.includes('&provider=') && providerFilter !== '') {
      filter_category = '';
    }

    let requestUrl = `/courses/category?page=${page}&limit=${limit}${company ? `&provider=${company}` : ''}${providerFilter === null ? '' : providerFilter}${courseTypeFilter}${learningProgramFilter}${deliveryFilter}${durationFilter}${languageFilter}${filter_category}${activePriceFilter}&sort=${activeSort}${Router.query.search ?`&q=${Router.query.search}` : ''}`;

    const response = await lereroFetch('GET', requestUrl);

    // Remove the currentParams/window.history logic and use this instead:
    const currentQuery = { ...Router.query };
    const newParamsSource = requestUrl.split('?')[1] || '';
    const newParams = new URLSearchParams(newParamsSource);

    // 1. Clean up old non-permanent keys
    const permanentKeys = ['products', 'name', 'bundles', 'provider', 'q', 'search', 'category', 'courses'];
    Object.keys(currentQuery).forEach(key => {
        if (!newParams.has(key) && !permanentKeys.includes(key)) {
            delete currentQuery[key];
        }
    });

    // 2. Add new active filters
    newParams.forEach((value, key) => {
        if (value && value !== 'null' && value !== 'undefined') {
            currentQuery[key] = value;
        }
    });

    // 3. Keep category set to 'all' as per your requirement
    currentQuery.category = 'all';

    // 4. Update the URL using Next.js Router (STOPS THE REFRESH LOOP)
    Router.replace({
        pathname: Router.pathname,
        query: currentQuery,
    }, undefined, { shallow: true });

    if (response.success) {
      const appliedFilters = {};

      if (courseTypeFilter) appliedFilters.course_type = courseTypeFilter;
      if (learningProgramFilter) appliedFilters.learning_program = learningProgramFilter;
      if (deliveryFilter) appliedFilters.delivery = deliveryFilter;
      if (durationFilter) appliedFilters.duration = durationFilter;
      if (languageFilter) appliedFilters.language = languageFilter;
      if (providerFilter) appliedFilters.provider = providerFilter;
      if (filter_category) appliedFilters.category = filter_category;

      const isFilter = Object.keys(appliedFilters).length > 0;
      let new_data = [];
      response.data?.data.forEach((data) => {
        data.price = data.price;
        new_data.push(data);
      });

      setDisplayedItem(new_data);
      let tmp_pagination = response.data.meta;
      tmp_pagination.current_page = page;
      tmp_pagination.last_page = response.data.meta.total_pages;
      setPagination(tmp_pagination);
      if (isFilter) {
        const previousFilters = previousFiltersRef.current;
        Object.entries(appliedFilters).forEach(([key, value]) => {
          trackFilterApplied({
            page_type: 'category',
            filter_type: key,
            filter_value: value?.split('=')[1] || '',
          });
        });
        Object.entries(previousFilters).forEach(([key, value]) => {
          if (!appliedFilters[key]) {
            trackFilterCleared({
              page_type: 'category',
              filter_type: key,
              filter_value: value?.split('=')[1] || '',
            });
          }
        });
      } else {
        Object.entries(previousFiltersRef.current).forEach(([key, value]) => {
          trackFilterCleared({
            page_type: 'category',
            filter_type: key,
            filter_value: value?.split('=')[1] || '',
          });
        });
      }
      previousFiltersRef.current = appliedFilters;
      trackViewItemList({
        page_type: 'category',
        list_name: 'courses',
        items: response.data?.data?.map((item, index) => ({
          item_id: item.courseId,
          item_name: item.name,
          item_category: item.categoryName || 'unknown',
          item_list_name: 'courses',
          list_position: index + 1,
          price: Number(item.price) || 0,
        })),
      });
      setIsLoading(false);
    }
  };

  /**
   * Load all product based on filter
   * @param page page of the product, default is 1,
   * @param limit total product in one page, default is 10
   */
  const loadItems = async ({
    page = 1,
    limit = 10,
    variation,
    additionalFilter = '',
    priceFilterOverride,
    sortOverride,
  }) => {
    const activePriceFilter = typeof priceFilterOverride === 'string' ? priceFilterOverride : priceFilter;
    const activeSort = sortOverride ?? sort;

    // setIsLoading(true);
    let appliedFilters = {};
    let response = null;
    let dataType = '';
    let requestUrl = '';
    let keyword = '';
    
    if (variation === BUNDLE) {
      dataType = 'bundles';
      requestUrl = `/bundles?page=${page}&limit=${limit}${
        company ? `&provider=${company}` : ''
      }${learningProgramFilter}${deliveryFilter}${durationFilter}${activePriceFilter}${typeFilter}${readingTimeFilter}${languageProductFilter}${
        providerProductFilter === null ? '' : providerProductFilter
      }&sort=${activeSort}${Router.query.search ?`&q=${Router.query.search}` : ''}`;
    } else if (variation === PRODUCT) {
      dataType = 'products';
      requestUrl = `/products?page=${page}&limit=${limit}${
        company ? `&provider=${company}` : ''
      }${learningProgramFilter}${deliveryFilter}${durationFilter}${activePriceFilter}${typeFilter}${readingTimeFilter}${languageProductFilter}${
        providerProductFilter === null ? '' : providerProductFilter
      }&sort=${activeSort}${Router.query.search ?`&q=${Router.query.search}` : ''}`;
    } else {
      keyword = localStorage.getItem('category_name') ?? '';

      if (!keyword.includes(`&q=`)) {
        keyword = '';
      }

      requestUrl = `/items?page=${page}&limit=${limit}${courseTypeFilter}${clusterFilter}${keyword}${learningProgramFilter}${deliveryFilter}${durationFilter}${activePriceFilter}${typeFilter}${readingTimeFilter}${languageFilter}${
        providerFilter === null ? '' : providerFilter
      }&sort=${activeSort}${additionalFilter || ''}`;
    }

    console.log('Request URL:', requestUrl); // Debug: Check the constructed URL
    
    response = await lereroFetch('GET', requestUrl);

    // With this:
    const queryToUpdate = { ...Router.query };

    // Remove old filters that aren't in the current request
    const activeParams = new URLSearchParams(requestUrl.split('?')[1]);
    const permanentKeys = ['products', 'category', 'name', 'bundles', 'provider', 'q', 'search', 'courses'];

    Object.keys(queryToUpdate).forEach(key => {
      if (!activeParams.has(key) && !permanentKeys.includes(key)) {
        delete queryToUpdate[key];
      }
    });

    // Add new params
    activeParams.forEach((value, key) => {
      if (value && value !== 'null') {
        queryToUpdate[key] = value;
      }
    });

    // Force category to 'all' as per your original logic
    queryToUpdate.category = 'all';

    // Use Next.js Router to update the URL without a full refresh
    Router.replace({
      pathname: Router.pathname,
      query: queryToUpdate,
    }, undefined, { shallow: true });

    if (response.data?.meta?.totals === 0) {
      trackSearchNoResults({
        page_type: 'category',
        search_term: keyword?.split('=')[1] || '',
        search_location: Router.asPath,
      });
    } else {
      trackSearchPerformed({
        page_type: 'category',
        search_term: keyword?.split('=')[1] || '',
        results_count: response.data?.meta?.totals || 0,
        search_location: Router.asPath,
      });
    }
    appliedFilters = extractFiltersFromUrl(requestUrl);

    if (response.success) {
      const isFilter = Object.keys(appliedFilters).length > 0;

      let new_data = [];
      response.data?.data.forEach((data) => {
        data.price = data.price;
        new_data.push(data);
      });

      const manipulatedResponse = new_data.map((item) => {
        return {
          ...item,
          courseOrganizer: {
            logo: item.provider?.logo,
            name: item.provider?.name,
            code: item.provider?.code,
          },
        };
      });

      setDisplayedItem(manipulatedResponse);

      let tmp_pagination = response.data.meta;
      tmp_pagination.current_page = page;
      tmp_pagination.last_page = response.data.meta.total_pages;
      setPagination(tmp_pagination);

      if (isFilter) {
        const previousFilters = previousFiltersRef.current;

        Object.entries(appliedFilters).forEach(([key, value]) => {
          trackFilterApplied({
            page_type: 'category',
            filter_type: key,
            filter_value: value,
          });
        });

        Object.entries(previousFilters).forEach(([key, value]) => {
          if (!appliedFilters[key]) {
            trackFilterCleared({
              page_type: 'category',
              filter_type: key,
              filter_value: value,
            });
          }
        });
      } else {
        Object.entries(previousFiltersRef.current).forEach(([key, value]) => {
          trackFilterCleared({
            page_type: 'category',
            filter_type: key,
            filter_value: value?.split('=')[1] || '',
          });
        });
      }

      previousFiltersRef.current = appliedFilters;

      trackViewItemList({
        page_type: 'category',
        list_name: dataType,
        items: response.data?.data?.map((item, index) => ({
          item_id: item.productId || item.bundleId,
          item_name: item.name,
          item_category: item?.categoryName || 'unknown',
          item_list_name: dataType,
          list_position: index + 1,
          price: Number(item.price) || 0,
        })),
      });

      setIsLoading(false);
    }

  };

  /**
   * Load all course filter needed
   */
  const loadCourseFilter = async () => {
    // setIsLoading(true);
    let filter_category = localStorage.getItem('category_name');

    if (filter_category === '&categorySlug=all') {
      filter_category = '';
    }

    if (filter_category?.includes('&')) {
      filter_category = filter_category.split(' & ').join('-');
    }

    const filterSearch =  `${Router.query.search ?`&q=${Router.query.search}` : ''}`;

    const getAllCourseLevelFilter = lereroFetch('GET', `/courses/list/levels?` + filter_category + filterSearch);
    const getAllLearningProgramFilter = lereroFetch('GET', `/courses/list/learning-programs?` + filter_category + filterSearch);
    const getAllDeliveryFilter = lereroFetch('GET', `/courses/list/delivery-types?` + filter_category + filterSearch);
    const getAllDurationFilter = lereroFetch('GET', `/courses/list/durations?` + filter_category + filterSearch);
    const getAllLanguageFilter = lereroFetch('GET', `/courses/list/languages?` + filter_category + filterSearch);
    const getAllProviderFilter = lereroFetch('GET', `/courses/list/providers?` + filter_category + filterSearch);

    const response = await Promise.all([
      getAllCourseLevelFilter,
      getAllLearningProgramFilter,
      getAllDeliveryFilter,
      getAllDurationFilter,
      getAllLanguageFilter,
      getAllProviderFilter,
    ]);

    const newResponse = response.map((item, index) => {
      return {
        ...item,
        identifier: filterCourseOrder[index],
      };
    });

    const sanitizers = {
      provider: removeBlockedProviders,
      language: removeBlockedLanguages,
    };

    if (newResponse.every((item) => item.success)) {
      newResponse.forEach((res) => {
        const sanitizer = sanitizers[res.identifier];

        if (res.identifier === 'duration') {
          const newData = res.data.map((item) => ({
            id: item.id,
            name: item.value,
            count: item.count,
          }));
          filterCourseCollection[res.identifier].setFilterData(newData);
        } else {
          const filteredData = sanitizer ? sanitizer(res.data) : res.data;
          filterCourseCollection[res.identifier].setFilterData(filteredData);
        }
      });
    } else {
      alert('Something is wrong');
    }
  };

  // 1. Simple helper to format "&key=value"
  const getFilter = (key, value) => (value ? `&${key}=${value}` : '');

  const loadBundleFilter = async () => {
    setIsLoading(true);

    const { query } = Router;
    const urlAdditional = `${getFilter('type', query.type)}${getFilter('price', query.price)}${getFilter('language', query.language)}${getFilter('readingTime', query.readingTime)}${getFilter('duration', query.duration)}`;
    const filterSearch =  `${Router.query.search ?`&q=${Router.query.search}` : ''}`;

    const getAllTypeFilter = lereroFetch('GET', `/bundles/list/types?${urlAdditional}` + filterSearch);
    const getAllPriceFilter = lereroFetch('GET', `/bundles/list/prices?${urlAdditional}` + filterSearch);
    const getAllLanguageFilter = lereroFetch('GET', `/bundles/list/languages?${urlAdditional}` + filterSearch);
    const getAllDurationFilter = lereroFetch('GET', `/bundles/list/duration?${urlAdditional}` + filterSearch);
    const getAllReadingTimeFilter = lereroFetch('GET', `/bundles/list/reading-times?${urlAdditional}` + filterSearch);
    const getAllProviderFilter = lereroFetch('GET', `/bundles/list/providers?${urlAdditional}` + filterSearch);

    const response = await Promise.all([
      getAllTypeFilter,
      getAllPriceFilter,
      getAllLanguageFilter,
      getAllReadingTimeFilter,
      getAllDurationFilter,
      getAllProviderFilter,
    ]);

    if (response.every((item) => item.success)) {
      response.forEach((res) => {
        if (res.key === 'type' || res.key === 'language') {
          const newData = res.data.map((item) => {
            return {
              id: item.slug,
              name: item.name,
              count: item.count,
            };
          });

          const filteredLanguages = res.key === 'language' ? removeBlockedLanguages(newData) : newData;
          filterBundleCollection[res.key].setFilterData(filteredLanguages);
        } else {
          if (res.key === 'provider') {
            const filteredProviders = removeBlockedProviders(res.data);
            filterBundleCollection[res.key].setFilterData(filteredProviders);
          } else {
            filterBundleCollection[res.key].setFilterData(res.data);
          }
        }
      });
    } else {
      alert('Something is wrong with loading Bundle Filters');
    }
  };

  /**
   * Load all product filter needed
   */
  const loadProductFilter = async () => {
    setIsLoading(true);
    const filterSearch =  `${Router.query.search ?`&q=${Router.query.search}` : ''}`;
    const getAllPriceFilter = lereroFetch('GET', `/products/list/prices`+ filterSearch);
    const getAllTypeFilter = lereroFetch('GET', `/products/list/types`+ filterSearch);
    const getAllReadingTimeFilter = lereroFetch('GET', `/products/list/reading-times`+ filterSearch);
    const getAllLanguageFilter = lereroFetch('GET', `/products/list/languages`+ filterSearch);
    const getAllProviderFilter = lereroFetch('GET', `/products/list/providers`+ filterSearch);

    const response = await Promise.all([
      getAllPriceFilter,
      getAllTypeFilter,
      getAllReadingTimeFilter,
      getAllLanguageFilter,
      getAllProviderFilter,
    ]);

    const newResponse = response.map((item, index) => {
      return {
        ...item,
        identifier: filterProductOrder[index],
      };
    });

    if (newResponse.every((item) => item.success)) {
      newResponse.forEach((res) => {
        if (res.identifier === 'type' || res.identifier === 'language') {
          const newData = res.data.map((item) => {
            return {
              id: item.slug,
              name: item.name,
              count: item.count,
            };
          });
          const filteredLanguages = res.identifier === 'language' ? removeBlockedLanguages(newData) : newData;
          filterProductCollection[res.identifier].setFilterData(filteredLanguages);
        } else {
          if (res.identifier === 'provider') {
            const filteredProviders = removeBlockedProviders(res.data);
            filterProductCollection[res.identifier].setFilterData(filteredProviders);
          } else {
            filterProductCollection[res.identifier].setFilterData(res.data);
          }
        }
      });
    } else {
      alert('Something is wrong');
    }
  };

  const loadItemFilter = async () => {
    setIsLoading(true);

    let slugFilterProvider = localStorage.getItem('category_name');

    if (slugFilterProvider === '&categorySlug=all') {
      slugFilterProvider = '';
    }

    if (slugFilterProvider?.includes('&')) {
      slugFilterProvider = slugFilterProvider.split(' & ').join('-');
    }

    const getAllPriceFilter = lereroFetch('GET', `/items/list/prices?` + slugFilterProvider);
    const getAllTypeFilter = lereroFetch('GET', `/items/list/types?` + slugFilterProvider);
    const getAllReadingTimeFilter = lereroFetch('GET', `/items/list/reading-times?` + slugFilterProvider);
    const getAllLanguageFilter = lereroFetch('GET', `/items/list/languages?` + slugFilterProvider);
    const getAllProviderFilter = lereroFetch('GET', `/items/list/providers?` + slugFilterProvider);
    const getAllCourseTypeFilter = lereroFetch('GET', `/items/list/levels?` + slugFilterProvider);
    const getAllLearningProgramFilter = lereroFetch('GET', `/items/list/learning-programs?` + slugFilterProvider);
    const getAllDeliveryTypeFilter = lereroFetch('GET', `/items/list/delivery-types?` + slugFilterProvider);
    const getAllDurationFilter = lereroFetch('GET', `/items/list/durations?` + slugFilterProvider);
    const getAllCluster = lereroFetch('GET', `/items/list/clusters?` + slugFilterProvider);

    const response = await Promise.all([
      getAllCourseTypeFilter,
      getAllLearningProgramFilter,
      getAllDeliveryTypeFilter,
      getAllDurationFilter,
      getAllLanguageFilter,
      getAllProviderFilter,
      getAllPriceFilter,
      getAllTypeFilter,
      getAllReadingTimeFilter,
      getAllCluster
    ]);

    const newResponse = response.map((item, index) => {
      return {
        ...item,
        identifier: filterItemOrder[index],
      };
    });

    if (newResponse.every((item) => item.success)) {
      newResponse.forEach((res) => {
        if (res.identifier === 'type' || res.identifier === 'language') {
          const newData = res.data.map((item) => {
            return {
              id: item.slug,
              name: item.name,
              count: item.count,
            };
          });
          const filteredLanguages = res.identifier === 'language' ? removeBlockedLanguages(newData) : newData;
          filterItemCollection[res.identifier].setFilterData(filteredLanguages);
        } else if (res.identifier === 'duration') {
          const newData = res.data.map((item) => {
            return {
              id: item.id,
              name: item.value,
              count: item.count,
            };
          });
          filterItemCollection[res.identifier].setFilterData(newData);
        } else {
          if (res.identifier === 'provider') {
            const filteredProviders = removeBlockedProviders(res.data);
            filterItemCollection[res.identifier].setFilterData(filteredProviders);
          } else {
            filterItemCollection[res.identifier].setFilterData(res.data);
          }
        }
      });
    } else {
      alert('Something is wrong');
    }
  };

  /**
   * Handle filter data when filter is checked or unchecked
   * @param id {string} id of the filter item,
   * @param identifier {string} filter section identifier, each filter has one identifier, refer to filterCourseOrder array
   */
  const handleFilter = (id, identifier) => {
    if(identifier === 'price') {
      handleSortChange('lowest');
      setPriceFilter(`&minPrice=${id.min}&maxPrice=${id.max}`);
    } else {
      // setIsLoading(true);
      const collection = usedCollection[displayedItemVariation].filterCollection;
      let tmp_filter = [...collection[identifier].checkedData];
  
      if (!tmp_filter.includes(id)) {
        tmp_filter.push(id);
      } else {
        tmp_filter = tmp_filter.filter((data) => data !== id);
      }
  
      if (tmp_filter.length === 0) {
        collection[identifier].setFilterSlug('');
        collection[identifier].setCheckedData([]);
        return;
      }

      collection[identifier].setFilterSlug(collection[identifier].slug + tmp_filter.join(','));
      collection[identifier].setCheckedData(tmp_filter);
    }
  };

  /**
   * function for handle item to be added to cart
   * @param {string} slug slug of item that will be added to cart
   * @param {string} displayedItemVariation type of the item
   * @returns
   */
  const handleAddToCart = async (slug, displayedItemVariation) => {
    setIsLoading(true);
    let data;
    let isItemProduct = false;
    const type = displayedItem?.find((data) => data.slug === slug)?.source?.toUpperCase() || displayedItemVariation;

    switch (type) {
      case PRODUCT:
        data = await getProductDetail(slug);
        isItemProduct = true;
        break;
      case COURSE_AND_PRODUCT:
        data = await getProductDetail(slug);
        isItemProduct = true;
        break;
      case BUNDLE:
      case PRODUCT_BUNDLE:
        data = await getBundleDetails(slug);
        break;
      default:
        data = await getCourseDetail(slug);
        break;
    }

    if (!data) {
      toast.warning('Course information not found, Unable to add to cart');
      setIsLoading(false);
      return;
    }

    // sync cart data to be have same property
    const newCart = synchronizedSingleCartData({ item: data, isProduct: isItemProduct });

    let list_cart = [...cart];
    let new_data = [];
    let openModal = false;

    if (list_cart.filter((cart) => cart.itemId == newCart.itemId).length !== 0) {
      new_data = list_cart.filter((cart) => cart.itemId !== newCart.itemId);
    } else {
      list_cart.forEach((list) => {
        new_data.push(list);
      });
      new_data.push(newCart);
      openModal = true;
    }

    // sync cart data to be have same property
    const synchronizedCartData = new_data.map((item) => {
      return synchronizedSingleCartData({ item: item, isProduct: item.isProduct || false });
    });

    setCart(synchronizedCartData);
    localStorage.setItem('cart', JSON.stringify(synchronizedCartData));

    if (openModal) setOpenModalCheckout(true);
    else Router.reload(window.location.href);

    setIsLoading(false);
  };

  // function handleOpenFilterSort(type = 'filter') {
  //   if (type === 'filter' && showSort) {
  //     setFilter(!filter);
  //     setShowSort(false);
  //   }
  //   if (type === 'sort' && filter) {
  //     setFilter(false);
  //     setShowSort(!showSort);
  //   }
  // }

  /**
   *
   * @param {string} id id of selected item
   * @returns status of items wherter it's already in cart or no
   */
  const handleIsAlreadyInCart = (id) => {
    const arr = cart.filter((item) => item.itemId === id);

    if (arr.length > 0) return true;
    return false;
  };

  /**
   * Used for filter in mobile view, when filter applied by click 'Apply Button'
   */
  const handleApplyFilterByClick = async () => {
    const nextPriceFilter = getPriceRangeFilter(minPrice, maxPrice, availablePriceBounds);
    const nextSort = nextPriceFilter ? 'lowest' : sort;

    setPriceFilter(nextPriceFilter);

    if (nextPriceFilter && sort !== 'lowest') {
      handleSortChange('lowest');
    }

    if (displayedItemVariation === PRODUCT) {
      await loadItems({ variation: PRODUCT, priceFilterOverride: nextPriceFilter, sortOverride: nextSort });
      setTotalFilterProductApplied(getSelectedFilterCount(PRODUCT));
    }

    if (displayedItemVariation === BUNDLE) {
      await loadItems({ variation: BUNDLE, priceFilterOverride: nextPriceFilter, sortOverride: nextSort });
      setTotalFilterBundlesApplied(getSelectedFilterCount(BUNDLE));
    }

    if (displayedItemVariation === COURSE) {
      await loadCourses(1, 10, { priceFilterOverride: nextPriceFilter, sortOverride: nextSort });
      setTotalFilterCourseApplied(getSelectedFilterCount(COURSE));
    }

    if (displayedItemVariation === COURSE_AND_PRODUCT) {
      await loadItems({
        variation: COURSE_AND_PRODUCT,
        priceFilterOverride: nextPriceFilter,
        sortOverride: nextSort,
      });
      setTotalFilterItemApplied(getSelectedFilterCount(COURSE_AND_PRODUCT));
    }

    setIsLoading(false);
    setIsFilterTriggeredByOnClick(false);
    setIsFilterMobileOpened(false);
  };

  const onChangePage = (value) => {
    if (displayedItemVariation === BUNDLE) loadItems({ page: value, limit: 10, variation: BUNDLE });
    if (displayedItemVariation === PRODUCT) loadItems({ page: value, limit: 10, variation: PRODUCT });
    if (displayedItemVariation === COURSE) loadCourses(value, 10);
    if (displayedItemVariation === COURSE_AND_PRODUCT)
      loadItems({ page: value, limit: 10, variation: COURSE_AND_PRODUCT });
  };

  useEffect(() => {
    let cart = [];
    if (localStorage.getItem('cart')) {
      cart = JSON.parse(localStorage.getItem('cart'));
    }

    const newCart = cart.map((cartItem) => {
      return synchronizedSingleCartData({ item: cartItem, isProduct: cartItem.isProduct || false });
    });

    setCart(newCart);
    setIsLoading(false);

    return () => {
      localStorage.removeItem('category_name');
    };
  }, []);

  const handleRename = (name) => {
    console.log(name);
    let tmp_category_name = name?.split('=')[1].replace('%26', ' ');
    tmp_category_name = tmp_category_name.replace('&-', '& ');
    tmp_category_name = tmp_category_name.replace('-&', ' & ');
    tmp_category_name = tmp_category_name.replace('-', ' ');

    return tmp_category_name;
  };

  const handleResetFilter = useCallback(
    (variation) => {
      if (variation === PRODUCT) {
        setTotalFilterProductApplied(0);
      }
      if (variation === COURSE) {
        setTotalFilterCourseApplied(0);
      }
      if (variation === COURSE_AND_PRODUCT) {
        setTotalFilterItemApplied(0);
      }
      if (variation === BUNDLE) {
        setTotalFilterBundlesApplied(0);
      }

      const collection = usedCollection[variation].filterCollection;

      for (let key in collection) {
        collection[key].setCheckedData([]);
        collection[key].setFilterData([]);
        collection[key].setFilterSlug('');
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const handleResetCurrentMobileFilters = () => {
    const collection = usedCollection[displayedItemVariation]?.filterCollection || {};

    for (let key in collection) {
      collection[key].setCheckedData([]);
      collection[key].setFilterSlug('');
    }

    setPriceFilter('');
    setMinPrice(availablePriceBounds.min);
    setMaxPrice(availablePriceBounds.max);
  };


  useEffect(() => {
    if (Router.isReady && Object.keys(Router.query).length !== 0) {
      // ${courseTypeFilter}${learningProgramFilter}${deliveryFilter}${durationFilter}${languageFilter}${filter_category}&sort=${sort}${priceFilter}
      const { query } = Router;

      // 1. Simple helper to format "&key=value"
      const getFilter = (key, value) => (value ? `&${key}=${value}` : '');

      // 2. Sync API Filter Strings
      setSort(query.sort || 'newest');
      
      if (Object.keys(Router.query).includes('bundles')) {
        if (displayedItemVariation !== BUNDLE) {
          setDisplayedItemVariation(BUNDLE);
        }

        handleResetFilter(BUNDLE);

        setTypeFilter(getFilter('type', query.type));
        setFilterType(query.type ? query.type.split(',') : []);
        
        setLanguageProductFilter(getFilter('language', query.language));
        setFilterLanguageProduct(query.language ? query.language.split(',') : []);

        setProviderProductFilter(getFilter('provider', query.provider));
        setFilterProvider(query.provider ? query.provider.split(',') : []);

        if (query.minPrice && query.maxPrice) {
          setPriceFilter(`&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}`);
          setMinPrice(Number(query.minPrice));
          setMaxPrice(Number(query.maxPrice));
        }

        const loadDisplayedItem = async () => {
          localStorage.removeItem('category_name');
          await loadBundleFilter();
          setCategoryName('');

          if(!query.type && !query.language && !query.provider && !(query.minPrice && query.maxPrice)) {
            await loadItems({ variation: BUNDLE });
          }
        };

        loadDisplayedItem();
        return;
      }

      // if user access product from navbar
      if (Object.keys(Router.query).includes('products')) {
        console.log('masuk product');
        if (displayedItemVariation !== PRODUCT) setDisplayedItemVariation(PRODUCT);
        handleResetFilter(PRODUCT);
        
        setCourseTypeFilter(getFilter('courseType', query.courseType));
        setFilterCourseType(query.courseType ? query.courseType.split(',') : []);
        
        setDeliveryFilter(getFilter('deliveryType', query.deliveryType));
        setFilterDelivery(query.deliveryType ? query.deliveryType.split(',') : []);
        
        setLanguageProductFilter(getFilter('language', query.language));
        setFilterLanguageProduct(query.language ? query.language.split(',') : []);

        setTypeFilter(getFilter('type', query.type));
        setFilterType(query.type ? query.type.split(',') : []);
        
        setProviderProductFilter(getFilter('provider', query.provider));
        setFilterProvider(query.provider ? query.provider.split(',') : []);

        setReadingTimeFilter(getFilter('readingTime', query.readingTime));
        setFilterReadingTime(query.readingTime ? query.readingTime.split(',').map(Number) : []);

        if (query.minPrice && query.maxPrice) {
          setPriceFilter(`&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}`);
          setMinPrice(Number(query.minPrice));
          setMaxPrice(Number(query.maxPrice));
        }

        const loadDisplayedItem = async () => {
          localStorage.removeItem('category_name');
          await loadProductFilter();
          setCategoryName('');
          
          if(!query.type && !query.readingTime && !query.language && !query.provider && !(query.minPrice && query.maxPrice)) {
            await loadItems({ variation: PRODUCT });
          }
        };

        loadDisplayedItem();
        return;
      }

      // if user access search something
      if (Object.keys(Router.query).includes('search')) {
        if (displayedItemVariation !== COURSE_AND_PRODUCT) setDisplayedItemVariation(COURSE_AND_PRODUCT);
        handleResetFilter(COURSE_AND_PRODUCT);

        setCourseTypeFilter(getFilter('courseType', query.courseType));
        setFilterCourseType(query.courseType ? query.courseType.split(',') : []);

        setClusterFilter(getFilter('cluster', query.cluster));
        setFilterCluster(query.cluster ? query.cluster.split(',') : []);
        
        setDeliveryFilter(getFilter('deliveryType', query.deliveryType));
        setFilterDelivery(query.deliveryType ? query.deliveryType.split(',') : []);

        setLanguageFilter(getFilter('language', query.language));
        setFilterLanguage(query.language ? query.language.split(',') : []);

        setFilterProvider(Router.query.provider ? query.provider.split(',') : []);
        setProviderFilter(Router.query.provider ? '&provider=' + Router.query.provider : null);

        setReadingTimeFilter(getFilter('readingTime', query.readingTime));
        setFilterReadingTime(query.readingTime ? query.readingTime.split(',').map(Number) : []);

        setDurationFilter(getFilter('duration', query.duration));
        setFilterDuration(query.duration ? query.duration.split(',').map(Number) : []);

        setProviderProductFilter(getFilter('provider', query.provider));
        setFilterProvider(query.provider ? query.provider.split(',') : []);

        if (query.minPrice && query.maxPrice) {
          setPriceFilter(`&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}`);
          setMinPrice(Number(query.minPrice));
          setMaxPrice(Number(query.maxPrice));
        }

        const loadDisplayedItem = async () => {
          localStorage.setItem('category_name', `&q=${Router.query.search}`);
          await loadItemFilter();
          setCategoryName(Router.query.search);
          
          if(!query.courseType && !query.cluster && !query.deliveryType && !query.language && !query.readingTime && !query.provider && !(query.minPrice && query.maxPrice)) {
            await loadItems({ variation: COURSE_AND_PRODUCT });
          }
        };

        loadDisplayedItem();
        return;
      }

      if (Object.keys(Router.query).includes('learningProgram')) {
        console.log('masuk learning program');
        var program = Router.query.learningProgram.split(',');
        if (displayedItemVariation !== COURSE_AND_PRODUCT) setDisplayedItemVariation(COURSE_AND_PRODUCT);
        handleResetFilter(COURSE_AND_PRODUCT);

        setCourseTypeFilter(getFilter('courseType', query.courseType));
        setFilterCourseType(query.courseType ? query.courseType.split(',') : []);

        setClusterFilter(getFilter('cluster', query.cluster));
        setFilterCluster(query.cluster ? query.cluster.split(',') : []);

        setDeliveryFilter(getFilter('deliveryType', query.deliveryType));
        setFilterDelivery(query.deliveryType ? query.deliveryType.split(',') : []);

        setLanguageFilter(getFilter('language', query.language));
        setFilterLanguage(query.language ? query.language.split(',') : []);

        setReadingTimeFilter(getFilter('readingTime', query.readingTime));
        setFilterReadingTime(query.readingTime ? query.readingTime.split(',').map(Number) : []);

        setProviderProductFilter(getFilter('provider', query.provider));
        setFilterProvider(query.provider ? query.provider.split(',') : []);

        if (query.minPrice && query.maxPrice) {
          setPriceFilter(`&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}`);
          setMinPrice(Number(query.minPrice));
          setMaxPrice(Number(query.maxPrice));
        }
        
        const loadDisplayedItem = async () => {
          await loadItemFilter();
          setLearningProgramFilter('&learningProgram=' + program.join(','));
          setFilterLearningProgram(program);
          await loadItems({ variation: COURSE_AND_PRODUCT, additionalFilter: '&learningProgram=' + program.join(',') });
        };

        loadDisplayedItem();
        return;
      }

      // if user choose provider from navbar
      if (Object.keys(Router.query).includes('provider')) {
        console.log('masuk provider');
        if (displayedItemVariation !== COURSE_AND_PRODUCT) setDisplayedItemVariation(COURSE_AND_PRODUCT);
        handleResetFilter(COURSE_AND_PRODUCT);

        setCourseTypeFilter(getFilter('courseType', query.courseType));
        setFilterCourseType(query.courseType ? query.courseType.split(',') : []);

        setClusterFilter(getFilter('cluster', query.cluster));
        setFilterCluster(query.cluster ? query.cluster.split(',') : []);

        setDeliveryFilter(getFilter('deliveryType', query.deliveryType));
        setFilterDelivery(query.deliveryType ? query.deliveryType.split(',') : []);

        setLanguageFilter(getFilter('language', query.language));
        setFilterLanguage(query.language ? query.language.split(',') : []);

        setReadingTimeFilter(getFilter('readingTime', query.readingTime));
        setFilterReadingTime(query.readingTime ? query.readingTime.split(',').map(Number) : []);

        if (query.minPrice && query.maxPrice) {
          setPriceFilter(`&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}`);
          setMinPrice(Number(query.minPrice));
          setMaxPrice(Number(query.maxPrice));
        }
        
        setFilterProvider(Router.query.provider !== 'all' ? [Router.query.provider] : []);
        setProviderFilter(Router.query.provider !== 'all' ? '&provider=' + Router.query.provider : null);
        setCategoryName(Router.query.provider !== 'all' ? Router.query.name : '');
        localStorage.setItem(
          'category_name',
          Router.query.provider !== 'all' ? '&provider=' + Router.query.provider : ''
        );

        loadItemFilter();
        return;

        // if user choose category from navbar
      } else {
        if (displayedItemVariation !== COURSE) setDisplayedItemVariation(COURSE);
        const handleLoadCourse = async () => {
          // setIsLoading(true);
          handleResetFilter(COURSE);

          const listQueries = Object.keys(Router.query);
          let category_slug = listQueries.includes('category') ? '&categorySlug=' + Router.query.category : '';

          setCourseTypeFilter(getFilter('courseType', query.courseType));
          setFilterCourseType(query.courseType ? query.courseType.split(',') : []);
          
          setDeliveryFilter(getFilter('deliveryType', query.deliveryType));
          setFilterDelivery(query.deliveryType ? query.deliveryType.split(',') : []);

          setLanguageFilter(getFilter('language', query.language));
          setFilterLanguage(query.language ? query.language.split(',') : []);

          setFilterProvider(Router.query.provider ? query.provider.split(',') : []);
          setProviderFilter(Router.query.provider ? '&provider=' + Router.query.provider : null);

          setReadingTimeFilter(getFilter('readingTime', query.readingTime));
          setFilterReadingTime(query.readingTime ? query.readingTime.split(',').map(Number) : []);

          setDurationFilter(getFilter('duration', query.duration));
          setFilterDuration(query.duration ? query.duration.split(',').map(Number) : []);

          setProviderProductFilter(getFilter('provider', query.provider));
          setFilterProvider(query.provider ? query.provider.split(',') : []);

          if (query.minPrice && query.maxPrice) {
            setPriceFilter(`&minPrice=${query.minPrice}&maxPrice=${query.maxPrice}`);
            setMinPrice(Number(query.minPrice));
            setMaxPrice(Number(query.maxPrice));
          }

          setCategoryName(name ? name : handleRename(category_slug ? category_slug : '&categorySlug=all'));
          localStorage.setItem('category_name', category_slug);

          // set parent and parent url for breadcrumbs
          const category_name = category_slug;
          const queryParameters = new URLSearchParams(window.location.search);
          let _parent = queryParameters.get('parent');
          setParentUrl(_parent);

          const name = queryParameters.get('name');
          if (_parent) {
            _parent = _parent.replace('&', '& ');
          }
          if (_parent === 'health-fitness') {
            _parent = 'Health & Fitness';
          }
          setParent(_parent);

          // if filter provider already "", call this function
          if (category_name && !category_name.includes('&provider=') && providerFilter === '') {
            setCategoryName(name ? name : handleRename(category_name));

            if(!query.courseType && !query.deliveryType && !query.language && !query.provider && !query.readingTime && !query.duration && !(query.minPrice && query.maxPrice)) {
              await loadCourses();
            }
          }

          loadCourseFilter();
          setIsLoading(false);
        };

        handleLoadCourse();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Router.query.search, Router.isReady]);

  useEffect(() => {
    if (courseFirstRender.current) {
      courseFirstRender.current = false;
      return;
    }

    if (displayedItemVariation === COURSE && !Object.keys(Router.query).includes('products')) {
      if (!isFilterTriggeredByOnClick) {
        setTotalFilterCourseApplied(
          getSelectedFilterCount(COURSE)
        );
        const handleLoadCourse = async () => {
          await loadCourses();
          setIsLoading(false);
        };

        handleLoadCourse();
      }
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseTypeFilter, learningProgramFilter, priceFilter, deliveryFilter, durationFilter, languageFilter, providerFilter, sort]);

  useEffect(() => {
    if (productFirstRender.current) {
      productFirstRender.current = false;
      return;
    }

    
    if (displayedItemVariation === PRODUCT && Object.keys(Router.query).includes('products')) {
      console.log('masuk use effect product filter');
      if (!isFilterTriggeredByOnClick) {
        setTotalFilterProductApplied(
          getSelectedFilterCount(PRODUCT)
        );
        const handleLoadProduct = async () => {
          await loadItems({ variation: PRODUCT });
          setIsLoading(false);
        };

        handleLoadProduct();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageProductFilter, typeFilter, priceFilter, readingTimeFilter, providerProductFilter, sort]);

  useEffect(() => {
    if (productFirstRender.currefilternt) {
      productFirstRender.current = false;
      return;
    }
    if (displayedItemVariation === BUNDLE && Object.keys(Router.query).includes('bundles')) {
      if (!isFilterTriggeredByOnClick) {
        setTotalFilterProductApplied(
          getSelectedFilterCount(BUNDLE)
        );
        const handleLoadBundles = async () => {
          await loadItems({ variation: BUNDLE });
          setIsLoading(false);
        };

        handleLoadBundles();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languageProductFilter, typeFilter, priceFilter, providerProductFilter, sort]);

  useEffect(() => {
    if (itemFirstRender.current) {
      itemFirstRender.current = false;
      return;
    }

    
    if (
      displayedItemVariation === COURSE_AND_PRODUCT &&
      (Object.keys(Router.query).includes('provider') ||
      Object.keys(Router.query).includes('search') ||
      Object.keys(Router.query).includes('learningProgram'))
    ) {
      if (!isFilterTriggeredByOnClick) {
        setTotalFilterItemApplied(
          getSelectedFilterCount(COURSE_AND_PRODUCT)
        );

        const handleLoadItem = async () => {
          await loadItems({ variation: COURSE_AND_PRODUCT });
          setIsLoading(false);
        };

        handleLoadItem();
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    courseTypeFilter,
    learningProgramFilter,
    deliveryFilter,
    durationFilter,
    languageFilter,
    providerFilter,
    typeFilter,
    priceFilter,
    clusterFilter,
    readingTimeFilter,
    sort,
  ]);

  const pageCount = useMemo(() => {
    if (pagination && displayedItem) {
      if (displayedItem.length < pagination.per_page && pagination.current_page !== pagination.total_pages) {
        return 1;
      }
      return pagination.total_pages;
    }
    return -1;
  }, [pagination, displayedItem]);

  const { lookAndFeel, company } = useWhitelabelContext();

  const removeBlockedProviders = (data) => {
    return data.filter((item) => !BLOCKED_PROVIDERS.includes(item.name));
  };

  const removeBlockedLanguages = (data) => {
    return data.filter((item) => !BLOCKED_LANGUAGES.includes(item.name.trim()));
  };

  const extractFiltersFromUrl = (url) => {
    const params = new URLSearchParams(url.split('?')[1]);
    const filters = {};

    params.forEach((value, key) => {
      if (!['page', 'limit', 'sort'].includes(key)) {
        filters[key] = value;
      }
    });

    return filters;
  };

  const handleSortChange = (value) => {
    setSort(value);
    trackSortChanged({
      page_type: 'category',
      sort_value: value,
    });
  };

  // The function that actually handles the data
  const handleGetRangeData = useCallback((min, max) => {
    const nextPriceFilter = getPriceRangeFilter(min, max, availablePriceBounds);

    if (!nextPriceFilter) {
      setPriceFilter('');
      return;
    }

    if (sort !== 'lowest') {
      setSort('lowest');
      trackSortChanged({
        page_type: 'category',
        sort_value: 'lowest',
      });
    }

    setPriceFilter(nextPriceFilter);
  }, [availablePriceBounds, sort]);

  useEffect(() => {
    if (!isDispatch) {
      return undefined;
    }

    const getDataTimer = setTimeout(() => {
      handleGetRangeData(minPrice, maxPrice);
    }, 400);

    return () => clearTimeout(getDataTimer);
  }, [handleGetRangeData, isDispatch, maxPrice, minPrice]);

  useEffect(() => {
    setIsDispatch(true);
  }, []);

  return (
    <div>
      <Head>
        <title>
          {Router.asPath.includes('?category=all') || Router.asPath === '/category'
            ? 'All Categories'
            : categoryName?.replace(/(?:^|\s|["'([{])+\S/g, (match) => match.toUpperCase()).replace('+LMS', ' ').replace('Lerero & ', 'Lerero') || categoryName}
          {Router.asPath.includes('category?provider=all') ? 'All Providers' : ''}
          {Router.asPath.includes('category?products=all') ? 'All Products' : ''}
        </title>
      </Head>

      {isLoading ? (
        <div className="loading">
          <Spinner animation="border" variant="white" style={{ width: '50px', height: '50px' }} />
        </div>
      ) : null}

      <BreadcrumbSection asPath={Router.asPath} categoryName={categoryName} parent={parent} parentUrl={parentUrl} />

      <div className="category-wrapper pt-2">
        <section id="header">
          <TitleSection categoryName={categoryName}></TitleSection>

          <div className="row mt-5 d-none d-lg-flex">
            <div className="col-md-3 d-flex align-items-strecth">
              <button
                className="font-size-14 button-secondary margin-right-15 p-4"
                onClick={() => toggleClickFilterAndSort(filterAndSort === 'filter' ? '' : 'filter')}
              >
                <div className="display-flex">
                  <i className="bi bi-filter margin-right-10 font-size-16"></i> Filter
                </div>
              </button>
              <button
                className="font-size-14 button-secondary p-4"
                onClick={() => toggleClickFilterAndSort(filterAndSort === 'sort' ? '' : 'sort')}
              >
                <div className="display-flex justify-content-between">
                  Sort By
                  <i className={`bi font-size-10 ${filterAndSort === 'sort' ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
                </div>
              </button>
            </div>
          </div>
        </section>

        <section id="body">
          {/* Modal */}
          {openModalCheckout && <ModalCheckout setOpen={setOpenModalCheckout} open={openModalCheckout} />}
          <div className="row mt-4">
            <div className={`col-md-3 ${filterAndSort ? 'd-none d-lg-inline-block' : 'display-none'}`}>
              {filterAndSort == 'sort' && (
                <SortData title="Sort By" data={SORT_BY_ITEM} sort={sort} handleFilter={handleSortChange} />
              )}
              {filterAndSort == 'filter' && (
                <AllFilterComponent
                  itemVariation={displayedItemVariation}
                  fullWidth={false}
                  minPrice={minPrice}
                  setMinPrice={setMinPrice}
                  maxPrice={maxPrice}
                  setMaxPrice={setMaxPrice}
                  defaultMaxPrice={DEFAULT_MAX_PRICE}
                  handleFilter={handleFilter}
                  courseType={courseType}
                  filterCourseType={filterCourseType}
                  learningProgram={learningProgram}
                  filterLearningProgram={filterLearningProgram}
                  delivery={delivery}
                  filterDelivery={filterDelivery}
                  duration={duration}
                  filterDuration={filterDuration}
                  type={type}
                  filterType={filterType}
                  price={price}
                  filterPrice={filterPrice}
                  priceFilter={priceFilter}
                  readingTime={readingTime}
                  filterReadingTime={filterReadingTime}
                  language={language}
                  filterLanguage={filterLanguage}
                  provider={provider}
                  filterProvider={filterProvider}
                  languageProduct={languageProduct}
                  filterLanguageProduct={filterLanguageProduct}
                  providerProduct={providerProduct}
                  filterProviderProduct={filterProviderProduct}
                  slug={Router.query}
                  cluster={cluster}
                  filterCluster={filterCluster}
                ></AllFilterComponent>
              )}
            </div>
            <div className={`${filterAndSort ? 'col-12 col-lg-9' : 'col-12'}`}>
              {displayedItem ? (
                <div>
                  <div className="pagination-container mb-4">
                    {isMobile ? (
                      <div className="show-results font-weight-600 category-sub-title mb-0" style={{width: "120px", fontSize: "13px"}}>
                        Showing {pagination ? pagination.totals : 0}{' '}
                        {pagination && pagination.totals > 1 ? 'results' : 'result'}
                      </div>
                    ) : 
                    (
                      <SubHeading variety={3} className="show-results font-weight-600 category-sub-title mb-0">
                        Showing {pagination ? pagination.totals : 0}{' '}
                        {pagination && pagination.totals > 1 ? 'results' : 'result'}
                      </SubHeading>
                    )}
                    {pagination?.totals > 10 ? (
                      <MuiPagination
                        sx={styles({ bg: lookAndFeel.button.bg_color, textColor: lookAndFeel.button.text_color }).sx}
                        page={pagination?.current_page ?? 1}
                        count={pageCount}
                        onChange={(e, page) => onChangePage(page)}
                      />
                    ) : null}
                  </div>
                  {displayedItem.map((item, index) => {
                    let isItemProduct = null;
                    let itemId = null;
                    let itemSlug = null;

                    if (displayedItemVariation === PRODUCT) {
                      isItemProduct = true;
                      itemId = item.productId;
                      itemSlug = item.slug;
                    }

                    if (displayedItemVariation === BUNDLE || item.source === 'product_bundle') {
                      isItemProduct = false;
                      itemId = item.bundleId;
                      itemSlug = item.slug;
                    }

                    if (displayedItemVariation === COURSE) {
                      isItemProduct = false;
                      itemId = item.courseId;
                      itemSlug = item.courseSlug;
                    }

                    if (displayedItemVariation === COURSE_AND_PRODUCT) {
                      isItemProduct = item.source === 'product' ? true : false;
                      itemId = item.entityId;
                      itemSlug = item.slug;
                    }

                    if (displayedItemVariation === BUNDLE || item.source === 'product_bundle') {
                      return (
                        <CardBundle
                          key={index}
                          filter={filterAndSort}
                          data={item}
                          isAlreadyInCart={handleIsAlreadyInCart(itemId)}
                          handleAddToCart={() => handleAddToCart(itemSlug, BUNDLE)}
                        />
                      );
                    }

                    return (
                      <Card
                        isProduct={isItemProduct}
                        key={index}
                        filter={filterAndSort}
                        data={item}
                        slug={itemSlug}
                        isAlreadyInCart={handleIsAlreadyInCart(itemId)}
                        handleAddToCart={() => handleAddToCart(itemSlug, displayedItemVariation)}
                      />
                    );
                  })}
                  {pagination?.totals > 10 ? (
                    <div className="pagination-box">
                      <MuiPagination
                        sx={styles({ bg: lookAndFeel.button.bg_color, textColor: lookAndFeel.button.text_color }).sx}
                        page={pagination?.current_page ?? 1}
                        count={pageCount}
                        onChange={(e, page) => onChangePage(page)}
                      />
                    </div>
                  ) : null}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </section>

        {/* Button open filter in mmobile */}
        {isFilterMobileOpened ? null : (
          <OpenFilterButton
            handleClick={() => {
              const collection = usedCollection[displayedItemVariation]?.filterCollection || {};
              const nextSavedFilter = {
                priceRange: {
                  minPrice,
                  maxPrice,
                  priceFilter,
                },
                sort,
              };

              for (let key in collection) {
                nextSavedFilter[key] = {
                  checkedData: collection[key].checkedData,
                  slug: collection[key].checkedData.join(','),
                };
              }

              setSavedFilter(nextSavedFilter);
              setIsFilterMobileOpened(true);
              setIsFilterTriggeredByOnClick(true);
            }}
            total={usedCollection[displayedItemVariation]?.totalFilterApplied || 0}
          />
        )}

        {/* Bottomsheet for filter in mobile */}
        <BottomSheet opened={isFilterMobileOpened}>
          <div className="overflow-auto category-filter-item">
            <div className="font-size-20 font-weight-700 text-center">Filter/Sort By</div>
            <div className="category-filter-mobile-summary">
              <span className="category-filter-mobile-selected">
                {selectedFilterCount} {selectedFilterCount === 1 ? 'Item' : 'Items'} Selected
              </span>
              <button
                type="button"
                className="category-filter-mobile-reset"
                onClick={handleResetCurrentMobileFilters}
                disabled={selectedFilterCount === 0}
              >
                <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M11.4912 5.83697C11.9161 5.41205 12.6333 5.5621 12.8584 6.12017C13.1667 6.87851 13.333 7.71249 13.333 8.57916C13.3329 12.2623 10.3501 15.245 6.66699 15.2452V16.7452C6.66699 17.1118 6.21634 17.2955 5.95801 17.0372L3.63379 14.712C3.46712 14.5453 3.46712 14.2868 3.63379 14.1202L5.95801 11.796C6.21628 11.5294 6.66678 11.7122 6.66699 12.087V13.5792C9.42509 13.579 11.6669 11.3373 11.667 8.57916C11.667 7.92088 11.5331 7.28745 11.2998 6.70416C11.1748 6.41253 11.2663 6.06197 11.4912 5.83697ZM6.66699 0.420956C6.66699 0.0460522 7.11663 -0.137866 7.375 0.120175L9.7002 2.44537C9.86682 2.61199 9.86673 2.8705 9.7002 3.03717L7.375 5.36236C7.11666 5.62894 6.66699 5.44534 6.66699 5.07037V3.57916C3.90866 3.57916 1.66699 5.82083 1.66699 8.57916C1.66702 9.2374 1.79157 9.87923 2.0332 10.4542C2.15807 10.754 2.06663 11.0954 1.8418 11.3204C1.4168 11.7454 0.699609 11.5955 0.474609 11.0372C0.166358 10.279 3.24206e-05 9.44566 0 8.57916C0 4.89583 2.98366 1.91217 6.66699 1.91217V0.420956Z" fill="#E25C5C" />
                </svg>
                <span>Reset Filter</span>
              </button>
            </div>
            <SortData
              title="Sort By"
              data={SORT_BY_ITEM}
              sort={sort}
              handleFilter={handleSortChange}
              fullWidth={true}
              className="category-sort-mobile"
            />
            <AllFilterComponent
              itemVariation={displayedItemVariation}
              fullWidth={true}
              handleFilter={handleFilter}
              courseType={courseType}
              filterCourseType={filterCourseType}
              learningProgram={learningProgram}
              filterLearningProgram={filterLearningProgram}
              delivery={delivery}
              filterDelivery={filterDelivery}
              duration={duration}
              filterDuration={filterDuration}
              type={type}
              filterType={filterType}
              price={price}
              filterPrice={filterPrice}
              priceFilter={priceFilter}
              minPrice={minPrice}
              setMinPrice={setMinPrice}
              maxPrice={maxPrice}
              setMaxPrice={setMaxPrice}
              defaultMaxPrice={DEFAULT_MAX_PRICE}
              readingTime={readingTime}
              filterReadingTime={filterReadingTime}
              language={language}
              filterLanguage={filterLanguage}
              provider={provider}
              filterProvider={filterProvider}
              languageProduct={languageProduct}
              filterLanguageProduct={filterLanguageProduct}
              providerProduct={providerProduct}
              filterProviderProduct={filterProviderProduct}
              slug={Router.query}
              cluster={cluster}
              filterCluster={filterCluster}
            ></AllFilterComponent>
          </div>
          <div className="row category-filter-button-container">
            <div className="col-6">
              <Button
                variety={3}
                fontType={FONT_TYPES.textBody}
                type={BUTTON_TYPE.secondary}
                className="button button-outline p-0 w-100"
                onClick={async () => {
                  const collection = usedCollection[displayedItemVariation]?.filterCollection || {};

                  for (let key in collection) {
                    const savedData = savedFilter[key] || { checkedData: [], slug: '' };

                    collection[key].setCheckedData(savedData.checkedData);
                    collection[key].setFilterSlug(
                      savedData.checkedData.length > 0 ? collection[key].slug + savedData.slug : ''
                    );
                  }

                  setMinPrice(savedFilter.priceRange?.minPrice ?? DEFAULT_MIN_PRICE);
                  setMaxPrice(savedFilter.priceRange?.maxPrice ?? DEFAULT_MAX_PRICE);
                  setPriceFilter(savedFilter.priceRange?.priceFilter ?? '');
                  setSort(savedFilter.sort ?? 'newest');
                  setIsLoading(false);
                  await setIsFilterMobileOpened(false);
                  await setIsFilterTriggeredByOnClick(false);
                }}
              >
                Cancel
              </Button>
            </div>
            <div className="col-6">
              <Button
                variety={3}
                fontType={FONT_TYPES.textBody}
                type={BUTTON_TYPE.primary}
                className="button button-primary p-0 w-100"
                onClick={() => {
                  handleApplyFilterByClick();
                }}
              >
                Apply Filter
              </Button>
            </div>
          </div>
        </BottomSheet>
      </div>
    </div>
  );
}
